// extracted by mini-css-extract-plugin
export default {"areaSection":"styles_areaSection__JrV1e","professionSection":"styles_professionSection__GaVyP","emptyState":"styles_emptyState__Q2-hW"};